import type { ReactNode } from "react";

type AdminSingleDetailsTabProps = {
  ariaLabel: string;
  panelLabel: string;
  tabIdPrefix: string;
  children: ReactNode;
};

export const AdminSingleDetailsTab = ({
  ariaLabel,
  children,
  panelLabel,
  tabIdPrefix,
}: AdminSingleDetailsTabProps) => {
  const tabId = `${tabIdPrefix}-details-tab`;
  const panelId = `${tabIdPrefix}-details-panel`;

  return (
    <>
      <div
        aria-label={ariaLabel}
        className="admin-profile-tabs"
        role="tablist"
      >
        <button
          aria-controls={panelId}
          aria-selected="true"
          className="admin-profile-tab is-active"
          id={tabId}
          role="tab"
          type="button"
        >
          {panelLabel}
        </button>
      </div>
      <section
        aria-labelledby={tabId}
        className="admin-profile-panel is-active"
        id={panelId}
        role="tabpanel"
      >
        {children}
      </section>
    </>
  );
};
